import { useEffect } from "react";
import { connect } from "react-redux";
import { getReportByUser, setModule } from "../../actions/reportsActions";
import moment from "moment";
import Select from "../../components/Select/Select";
import ArrowGoBack from "../../components/ArrowGoBack/ArrowGoBack";
import icon from "../../assets/icons/Reports_Icons.png";
import csvIcon from "../../assets/icons/ExportCSV.png";
import styles from "./index.module.css";
import ReportsTable from "./reports_table_learner/reports_table_learner";
import { getModules } from "../../actions/productsActions";
import {
  closeLoading,
  openLoading,
} from "../../components/loadingModal/loading";
import AlertModal from "../../components/AlertModal/alertModal";

const LearnerView = (props) => {
  const {
    getReportByUser,
    data,
    userData,
    getModules,
    products,
    idModule,
    setModule,
  } = props;

  const getInitialData = async () => {
    openLoading();
    try {
      await getModules({ active: true, userProducts: true });
    } catch (error) {
      AlertModal({
        title: "ERROR",
        text: error.response.data.message,
      });
    } finally {
      closeLoading();
    }
  };

  useEffect(() => {
    console.log("reloaded learner view page", data);
    getInitialData();
  }, []);

  const name = userData.firstname + " " + userData.lastname;
  const timeSpent = Math.abs(data.timeSpent / 60).toFixed(2);
  const averageTime =
    timeSpent > 0 ? (timeSpent / data.reportUser.length).toFixed(2) : 0;
  const lastAccess = data.lastAccess
    ? moment(data.lastAccess).format("MMM DD, YYYY")
    : "not date";

  const handleSelect = async (e) => {
    openLoading();
    try {
      setModule(e.value.idModule);
      await getReportByUser({
        username: userData.username,
        idProduct: e.value.idModule,
      });
    } catch (error) {
      AlertModal({
        title: "ERROR",
        text: error.response.data.message,
      });
    } finally {
      closeLoading();
    }
  };

  return (
    <div className={`box-container ${styles.container2}`}>
      <ArrowGoBack />
      <div className={styles.header2}>
        <img src={icon} alt="Icon Details" className="icon_head" />
        <div className={styles.nameCon}>
          <div className={styles.name}>{name}</div>
          <div>{userData.username}</div>
        </div>
        <div className={styles.textGroup}>
          <div className={styles.title}>TOTAL SESSIONS</div>{" "}
          <div className={styles.subtitle}>{data.reportUser.length}</div>
          <div className={styles.title}>TOTAL TIME SPENT (MINS)</div>{" "}
          <div className={styles.subtitle}>
            {Math.floor(data.timeSpent / 60)}
          </div>
          <div className={styles.title}>AVERAGE TIME PER SESSION (MINS)</div>{" "}
          <div className={styles.subtitle}>
            {data.reportUser.length > 0
              ? Math.floor(data.timeSpent / 60 / data.reportUser.length)
              : 0}{" "}
          </div>
        </div>
        <div className={styles.textGroup2}>
          <div className={styles.title}>LAST ACCESS DATE</div>{" "}
          <div className={styles.subtitle}>{lastAccess}</div>
          <div className={styles.title}>GUIDED ATTEMPTS</div>{" "}
          <div className={styles.subtitle}>100%</div>
        </div>
      </div>
      <div className={styles.middle}>
        <div className={styles.selectCon}>
          <Select
            name="Module"
            options={products}
            title="Select Module"
            onChange={handleSelect}
            value={idModule}
            valueName="idModule"
          />
        </div>
        <button className={`button_dark_1 ${styles.exportBtn}`}>
          <img
            src={csvIcon}
            alt="Export csv"
            className={`icon_btn_1 ${styles.imgButton}`}
          />
          <div className="text_btn_dark_1">EXPORT CSV</div>
        </button>
      </div>
      <div className={styles.tableContainer}>
        <ReportsTable reports={data?.reportUser} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.metricIndividualReducer.reportUser,
    userData: state.usersReducer.userLogged,
    products: state.productsReducer.allProducts,
    idModule: state.metricIndividualReducer.idModule,
  };
};

export default connect(mapStateToProps, {
  getReportByUser,
  getModules,
  setModule,
})(LearnerView);
